import { API_URL } from '@webapp/common/conf';

import { createIFrameId, createSurveyUrl, createTriggerId, EmbedShow, frame, onLoad, request, resize } from './common';

const url = `${API_URL}/core/v1/get/embed`;

const throttle = (type: string, name: string): void => {
    let scrollTimeout = null;
    const func = (): void => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
            window.dispatchEvent(new CustomEvent(name));
        }, 66);
    };
    window.addEventListener(type, func);
};

throttle('scroll', 'ttScrollEnd');
throttle('resize', 'ttScrollEnd');

window.ttgrafSetEmbedParams = ({
    id,
    scrollToInvalid = false,
    fixedHeaderHeight,
}: {
    id: number;
    scrollToInvalid?: boolean;
    fixedHeaderHeight?: number | string;
}): void =>
    request(url, { survey: id }, ({ response }) => {
        const { params, rewrite } = JSON.parse(response);
        const { embedLinkName, embedShow } = JSON.parse(params);
        const container = document.getElementById(createIFrameId(id));

        const iframe = frame(id);
        iframe.src = createSurveyUrl(rewrite, 'embed', true);
        iframe.style.display = embedShow === EmbedShow.LOAD_READY ? 'block' : 'none';

        container.appendChild(iframe);

        if (embedShow === EmbedShow.CLICK_LINK) {
            const triggerId = createTriggerId(id);
            const trigger = document.getElementById(triggerId);

            if (trigger) {
                trigger.innerText = embedLinkName;
                trigger.classList.add('active');
                trigger.addEventListener('click', () => {
                    iframe.style.display = 'block';
                    trigger.parentNode && trigger.parentNode.removeChild(trigger);
                });
            } else {
                console.error('Отсутствует кнопка ' + triggerId);
            }
        }

        let loaded = false;
        onLoad(() =>
            resize(iframe, ({ height }: AnyObject) => {
                // fixes resize on iOS
                container.style.height = height + 'px';
                iframe.style.minHeight = height + 'px';
                !loaded &&
                    window.addEventListener('ttScrollEnd', () => {
                        if (iframe) {
                            iframe.iFrameResizer.sendMessage([
                                'setFramePos',
                                JSON.stringify({
                                    scrollY: window.scrollY,
                                    scrollX: window.scrollX,
                                    height: window.innerHeight,
                                    width: window.innerWidth,
                                    box: iframe.getBoundingClientRect(),
                                }),
                            ]);
                        }
                    });
                loaded = true;
            }),
        );

        window.addEventListener('message', ({ data }) => {
            const [cmd, params] = typeof data === 'string' ? data.split('::') : [];

            switch (cmd) {
                case 'scrollTop':
                    setTimeout(() => {
                        let $fixedHeaderHeight = 0;

                        if (typeof fixedHeaderHeight === 'string') {
                            $fixedHeaderHeight = parseInt(fixedHeaderHeight);
                        } else if (typeof fixedHeaderHeight === 'number') {
                            $fixedHeaderHeight = fixedHeaderHeight;
                        }

                        window.scrollTo({ top: container.offsetTop - $fixedHeaderHeight });
                    }, 100);
                    break;
                case 'scrollTo':
                    if (scrollToInvalid) {
                        const { top } = JSON.parse(params);
                        const { offsetTop } = container;
                        window.scrollTo({ top: offsetTop + top });
                    }
                    break;
            }
        });
    });
